export default {
  /* AWS account */
  AWS_RESOURCES_ACCOUNT_SELECTION: 'AWS_RESOURCES_ACCOUNT_SELECTION',

  /* Dates */
  AWS_RESOURCES_SET_DATES: 'AWS_RESOURCES_SET_DATES',
  AWS_RESOURCES_RESET_DATES: 'AWS_RESOURCES_RESET_DATES',
  AWS_RESOURCES_CLEAR_DATES: 'AWS_RESOURCES_CLEAR_DATES',

  /* EC2 */
  AWS_RESOURCES_GET_EC2: 'AWS_RESOURCES_GET_EC2',
  AWS_RESOURCES_GET_EC2_SUCCESS: 'AWS_RESOURCES_GET_EC2_SUCCESS',
  AWS_RESOURCES_GET_EC2_ERROR: 'AWS_RESOURCES_GET_EC2_ERROR',
  AWS_RESOURCES_GET_EC2_CLEAR: 'AWS_RESOURCES_GET_EC2_CLEAR',

  /* RDS */
  AWS_RESOURCES_GET_RDS: 'AWS_RESOURCES_GET_RDS',
  AWS_RESOURCES_GET_RDS_SUCCESS: 'AWS_RESOURCES_GET_RDS_SUCCESS',
  AWS_RESOURCES_GET_RDS_ERROR: 'AWS_RESOURCES_GET_RDS_ERROR',
  AWS_RESOURCES_GET_RDS_CLEAR: 'AWS_RESOURCES_GET_RDS_CLEAR',

  /* ES */
  AWS_RESOURCES_GET_ES: 'AWS_RESOURCES_GET_ES',
  AWS_RESOURCES_GET_ES_SUCCESS: 'AWS_RESOURCES_GET_ES_SUCCESS',
  AWS_RESOURCES_GET_ES_ERROR: 'AWS_RESOURCES_GET_ES_ERROR',
  AWS_RESOURCES_GET_ES_CLEAR: 'AWS_RESOURCES_GET_ES_CLEAR',

  /* ELASTICACHE */
  AWS_RESOURCES_GET_ELASTICACHE: 'AWS_RESOURCES_GET_ELASTICACHE',
  AWS_RESOURCES_GET_ELASTICACHE_SUCCESS: 'AWS_RESOURCES_GET_ELASTICACHE_SUCCESS',
  AWS_RESOURCES_GET_ELASTICACHE_ERROR: 'AWS_RESOURCES_GET_ELASTICACHE_ERROR',
  AWS_RESOURCES_GET_ELASTICACHE_CLEAR: 'AWS_RESOURCES_GET_ELASTICACHE_CLEAR',

  /* LAMBDAS */
  AWS_RESOURCES_GET_LAMBDAS: 'AWS_RESOURCES_GET_LAMBDAS',
  AWS_RESOURCES_GET_LAMBDAS_SUCCESS: 'AWS_RESOURCES_GET_LAMBDAS_SUCCESS',
  AWS_RESOURCES_GET_LAMBDAS_ERROR: 'AWS_RESOURCES_GET_LAMBDAS_ERROR',
  AWS_RESOURCES_GET_LAMBDAS_CLEAR: 'AWS_RESOURCES_GET_LAMBDAS_CLEAR',
};



// WEBPACK FOOTER //
// ./src/constants/aws/resourcesTypes.js